import { useaxios } from "../../../../utils/useaxios";
export default (text) => studentDispatch => {
    useaxios('student/activesearch.php', { text, department_id: 3 }).then((res) => {
        if (res.status == "ok") {
            studentDispatch({ type: 'setactivesearch', payload: res.student });
        } else {
            // clear();
        }
    });
}